import React from "react";
import Clock from 'react-digital-clock';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

const Clockc = () => {
return (
    <><div className="bg-primary" style={{fontSize:'40px',padding:'20px 0'}}>
        <Clock />
        </div>
    </>
)


}

export default Clockc;